import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, ChevronLeft, ChevronRight } from 'react-feather';
import {
  Input,
  Row,
  Col,
  Button,
  UncontrolledAccordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Card,
  CardBody,
  CardHeader,
  Collapse,
} from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import dots from '../../../../../../../assets/images/dots.svg';
import mapVendor from '../../../../../../../assets/images/map-vendor.svg';
import { SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION } from '../../../../../../../store/actions';
import { useDispatch } from 'react-redux';
import cogoToast from 'cogo-toast';
import airplane from '../../../../../../../assets/images/airplane.svg';
import TypeCard from '../Comman/TypeCard';

const AssignZonesToVendors = ({ state, setState, setFormCount, isDraftConfiguration, configuration }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  console.log('State', state);
  const [searchText, setSearchText] = useState('');
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const containerRef = useRef(null);
  const itemRefs = useRef({});
  const [openAccordionId, setOpenAccordionId] = useState(null);

  console.log('openAccordionId', openAccordionId);

  const toggle = index => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  console.log('State', state);

  useEffect(() => {
    setSelectedVendor(state?.vendorPricing?.vendors?.[0] ?? []);
  }, []);

  useEffect(() => {
    if (openAccordionId && itemRefs.current[openAccordionId]) {
      const el = itemRefs.current[openAccordionId];
      const container = containerRef.current;

      if (el && container) {
        setTimeout(() => {
          const elTop = el.offsetTop;
          container.scrollTo({
            top: elTop - 20, // 20px scroll offset
            behavior: 'smooth',
          });
        }, 250); // slight delay to match accordion animation
      }
    }
  }, [openAccordionId]);

  const filteredAirports = state?.vendorPricing?.airports.filter(airport => airport.name.toLowerCase().includes(searchText.toLowerCase()));

  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const validateVendorZoneMapping = () => {
    const allZones =
      state?.vendorPricing?.airports?.flatMap(airport =>
        airport?.zones?.map(zone => ({
          id: zone?.id,
          airportId: airport?.id,
        })),
      ) || [];

    // Gather all zone assignments from all vendors
    const assignedZones =
      state?.vendorPricing?.vendors?.flatMap(vendor =>
        vendor?.zones?.map(zone => ({
          id: zone?.id,
          airportId: zone?.airport?.id,
        })),
      ) || [];

    // Find unassigned zones
    const unassignedZones = allZones?.filter(
      zone => !assignedZones.some(assigned => assigned.id === zone.id && assigned.airportId === zone.airportId),
    );

    if (unassignedZones.length > 0) {
      cogoToast.error('Please map all zones to at least one vendor');
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (!validateVendorZoneMapping()) return;
    setFormCount(prev => prev + 1);
  };

  const saveAsDraftHandler = () => {
    if (!validateVendorZoneMapping()) return;
    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: state?.vendorPricing,
            page: 8,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const updateAsDraftHandler = () => {
    if (!validateVendorZoneMapping()) return;
    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            client: state?.client,
            project: state?.project,
            benefit: state?.benefit,
            benefitGroup: state?.benefitGroup,
            vendorPricing: state?.vendorPricing,
            page: 8,
          },
          configuration_type: 'program_onboarding',
          status: 'DRAFT',
          id: configuration?.id,
        },
      },
    });
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <BreadcrumbTrail
            title={`Airport Configuration Setup`}
            navigationby={breadcrumNavigationHandler}
            navigation={['Management', 'Program', 'Onboarding', 'Mapping Zones to Vendors']}
          />
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between p-0">
            <h5 className="m-0 fw-semibold px-3">Assign Zones to the selected Vendors</h5>
            <TypeCard typeName={'Client'} name={state?.client?.name} />
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="7">
                <div className="position-relative border rounded p-3">
                  <Row className="align-items-center mb-3">
                    <Col md={6}>
                      <h5>Available Zones</h5>
                      <p className="text-muted">Drag Zones to vendors to create mappings</p>
                    </Col>
                    {/* <Col md={3}>
                      <Dropdown isOpen={airportDropdownOpen} toggle={toggleAirportDropdown}>
                        <DropdownToggle caret color="light" className="w-100">
                          All Airports
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>All Airports</DropdownItem>
                          <DropdownItem>DXB</DropdownItem>
                          <DropdownItem>Abu Dhabi</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                    <Col md={3}>
                      <Dropdown isOpen={zoneTypeDropdownOpen} toggle={toggleZoneTypeDropdown}>
                        <DropdownToggle caret color="light" className="w-100">
                          Zone Type
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem>All</DropdownItem>
                          <DropdownItem>Servicable</DropdownItem>
                          <DropdownItem>Non-servicable</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col> */}
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Input type="text" placeholder="Search Airport" value={searchText} onChange={e => setSearchText(e.target.value)} />
                    </Col>
                  </Row>

                  <div className="airport-zones-list" style={{ maxHeight: '212px', overflowY: 'auto' }} ref={containerRef}>
                    <UncontrolledAccordion stayOpen>
                      {filteredAirports.map(airport => (
                        <div
                          key={airport.id}
                          ref={el => {
                            if (el) itemRefs.current[airport.id] = el;
                          }}
                        >
                          <AccordionItem className="mb-2">
                            <AccordionHeader
                              targetId={airport.id}
                              onClick={() => setOpenAccordionId(openAccordionId === airport.id ? null : airport.id)}
                              className={openAccordionId === airport.id ? 'header-open' : ''}
                            >
                              <div className="w-100 d-flex justify-content-between align-items-center">
                                {/* Left Section */}
                                <div className="d-flex gap-2 align-items-center">
                                  <img src={airplane} alt="" style={{ width: '20px' }} />
                                  <div>
                                    <p className="m-0 fw-semibold">{airport.name}</p>
                                    <small className="text-muted">{airport?.zones?.length} Zones</small>
                                  </div>
                                </div>

                                {/* Right Section */}
                                <div className="d-flex align-items-center gap-2 me-3 cursor-pointer">
                                  <div
                                    className={`square-check-box ${
                                      airport?.zones?.length > 0 &&
                                      airport.zones.every(airportZone => selectedVendor?.zones?.some(vendorZone => vendorZone.id === airportZone.id))
                                        ? 'checked'
                                        : ''
                                    }`}
                                    onClick={e => {
                                      e.stopPropagation();

                                      const airportZones = airport?.zones || [];

                                      const findVendorIndex = state?.vendorPricing?.vendors?.findIndex(vendor => vendor?.id === selectedVendor?.id);
                                      if (findVendorIndex === -1) return;

                                      const vendor = state?.vendorPricing?.vendors[findVendorIndex];
                                      const existingZones = vendor?.zones || [];

                                      // Check if all zones of this airport are already selected
                                      const isAlreadySelected = airportZones.every(airportZone =>
                                        existingZones.some(vendorZone => vendorZone.id === airportZone.id),
                                      );

                                      // Compute new zones
                                      const newZones = isAlreadySelected
                                        ? existingZones.filter(vendorZone => !airportZones.some(az => az.id === vendorZone.id))
                                        : [...existingZones, ...airportZones.filter(az => !existingZones.some(vz => vz.id === az.id))];

                                      // Update vendors immutably
                                      const updatedVendors = [...state?.vendorPricing?.vendors];
                                      updatedVendors[findVendorIndex] = {
                                        ...vendor,
                                        zones: newZones,
                                      };

                                      // Sync both vendor list + selected vendor
                                      setSelectedVendor(prev => ({ ...prev, zones: newZones }));
                                      setState(prev => ({
                                        ...prev,
                                        vendorPricing: {
                                          ...prev?.vendorPricing,
                                          vendors: updatedVendors,
                                        },
                                      }));
                                    }}
                                  ></div>
                                  <p className="m-0 fw-semibold fs-10">Select All</p>
                                </div>
                              </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={airport.id}>
                              <Row>
                                {airport.zones.map((zone, index) => (
                                  <Col
                                    md={5}
                                    key={index}
                                    className="mb-2 p-2 rounded mx-2 cursor-pointer"
                                    style={{
                                      background:
                                        selectedVendor?.zones?.find(
                                          vendorZone => vendorZone?.id === zone?.id && vendorZone?.airport?.id === zone?.airport?.id,
                                        ) && '#A1E5F7',
                                      border: '1px solid #D1D1D1',
                                    }}
                                    onClick={() => {
                                      const findVendorIndex = state?.vendorPricing?.vendors?.findIndex(vendor => vendor?.id === selectedVendor?.id);

                                      if (findVendorIndex === -1) return;

                                      setActiveIndex(findVendorIndex);

                                      const vendor = state?.vendorPricing?.vendors[findVendorIndex];
                                      const existingZones = vendor?.zones || [];
                                      const zoneExists = existingZones?.some(z => z?.id === zone?.id && z?.airport?.id === zone?.airport?.id);

                                      let updatedZones = zoneExists
                                        ? existingZones.filter(z => !(z?.id === zone?.id && z?.airport?.id === zone?.airport?.id))
                                        : [...existingZones, zone];

                                      updatedZones = updatedZones?.map(updatedZone => {
                                        return {
                                          id: updatedZone?.id,
                                          name: updatedZone?.name,
                                          airport: updatedZone?.airport,
                                        };
                                      });

                                      const updatedVendors = [...state?.vendorPricing?.vendors];
                                      updatedVendors[findVendorIndex] = {
                                        ...vendor,
                                        zones: updatedZones,
                                      };

                                      setState(prev => ({
                                        ...prev,
                                        vendorPricing: {
                                          ...prev?.vendorPricing,
                                          vendors: updatedVendors,
                                        },
                                      }));
                                      setSelectedVendor(prev => ({
                                        ...prev,
                                        zones: updatedZones,
                                      }));
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-2">
                                      <img src={dots} alt="" />{' '}
                                      <p
                                        className="m-0 fw-medium"
                                        style={{
                                          color: '#000000',
                                          maxWidth: '100px',
                                          overflow: 'hidden',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {zone?.name}
                                      </p>
                                    </div>
                                    <p className="mt-1 m-0">
                                      {zone?.distanceType} {zone?.distanceType !== 'Polygon' && ` - ${zone?.zoneRange?.to ?? 0} Km`}
                                    </p>
                                  </Col>
                                ))}
                              </Row>
                            </AccordionBody>
                          </AccordionItem>
                        </div>
                      ))}
                    </UncontrolledAccordion>
                  </div>
                </div>
              </Col>

              <Col md="5">
                <div className="position-relative border rounded p-3">
                  <h5>Vendor list</h5>
                  <p className="text-muted small">Drop zones here to map them to vendors</p>
                  <div className="vendor-mapping-list">
                    {state?.vendorPricing?.vendors?.map((vendor, index) => (
                      <Card
                        key={index}
                        className="mb-3 cursor-pointer p-2"
                        style={{
                          border: selectedVendor?.id === vendor?.id ? '1px dashed black' : '1px dashed #D1D1D1',
                        }}
                        onClick={() => {
                          if (selectedVendor?.id !== vendor?.id) setSelectedVendor(vendor);
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between cursor-pointer" onClick={() => toggle(index)}>
                          <div className="d-flex flex-column pt-2 px-2">
                            <div className="d-flex gap-1 align-items-start">
                              <img className="mt-3" src={mapVendor} alt="" />
                              <div className="mt-2">
                                <div className="d-flex gap-2 align-items-center">
                                  <h6
                                    className="m-0 fw-medium fs-14"
                                    style={{
                                      maxWidth: '100px',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {vendor?.name || ''} {vendor?.firstName || ''} {vendor?.lastName || ''}
                                  </h6>
                                  <p
                                    style={{
                                      color: vendor?.tag === 'partially_configured' ? '#F59E0B' : '#0AB39C',
                                      border: vendor?.tag === 'partially_configured' ? '1px solid #F59E0B' : '1px solid #0AB39C',
                                      borderRadius: '20px',
                                      fontSize: '6px',
                                      maxWidth: '100px',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                    }}
                                    className="m-0 pt-1 pb-1 px-2 pe-2"
                                  >
                                    {vendor?.tag === 'partially_configured' ? 'Partially Configured' : 'Full Configured'}
                                  </p>
                                </div>
                                <div className="d-flex gap-2 mt-1">
                                  <p className="text-muted small m-0 mt-1">
                                    {vendor?.tag === 'partially_configured' ? vendor?.region?.value ?? '' : vendor?.region ?? ''}
                                  </p>
                                  <div className="d-flex flex-wrap gap-1">
                                    {vendor?.carTypes?.map((car, idx) => (
                                      <p
                                        key={idx}
                                        style={{
                                          borderRadius: '20px',
                                          padding: '5px 5px',
                                          fontSize: '8px',
                                          border: '1px solid #D0D2DC',
                                          color: '#6F7594',
                                          maxWidth: '100px',
                                          overflow: 'hidden',
                                          whiteSpace: 'nowrap',
                                          textOverflow: 'ellipsis',
                                        }}
                                        className="m-0"
                                      >
                                        {car?.name?.split(' ')[0]}
                                      </p>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p className="mt-2 text-muted mb-0 fs-10 m-1" style={{ fontStyle: 'italic' }}>
                              Drop zones here
                            </p>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            {activeIndex === index ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                          </div>
                        </div>
                        <Collapse isOpen={activeIndex === index}>
                          {vendor?.zones?.map(zone => (
                            <div
                              key={zone?.id}
                              className="d-flex justify-content-between align-items-center p-2 m-1 rounded-2"
                              style={{
                                border: '1px solid rgba(161, 229, 247, 1)',
                                background: 'rgba(236, 250, 253, 1)',
                              }}
                            >
                              <div
                                className="d-flex flex-column"
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                }}
                              >
                                <p
                                  className="fw-medium m-0 fs-12"
                                  style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                  }}
                                  title={zone?.name}
                                >
                                  {zone?.name}
                                </p>
                                <p
                                  className="fw-light m-0 fs-12"
                                  style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                  }}
                                  title={zone?.airport?.name}
                                >
                                  {zone?.airport?.name}
                                </p>
                              </div>

                              <p
                                className="cursor-pointer fs-12 m-0 ms-2"
                                style={{ color: '#E60000', flexShrink: 0 }}
                                onClick={() => {
                                  const vendor = state?.vendorPricing?.vendors[index];
                                  const existingZones = vendor?.zones || [];
                                  const updatedZones = existingZones.filter(z => z?.id !== zone?.id);
                                  const updatedVendors = [...state?.vendorPricing?.vendors];
                                  updatedVendors[index] = {
                                    ...vendor,
                                    zones: updatedZones,
                                  };
                                  setState(prev => ({
                                    ...prev,
                                    vendorPricing: {
                                      ...prev?.vendorPricing,
                                      vendors: updatedVendors,
                                    },
                                  }));
                                  setSelectedVendor(prev => ({
                                    ...prev,
                                    zones: updatedZones,
                                  }));
                                }}
                              >
                                Remove
                              </p>
                            </div>
                          ))}
                        </Collapse>
                      </Card>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount(prev => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{ backgroundColor: '#E9EBEC', color: '#404B7C', fontWeight: 500, boxShadow: 'none', border: 'none' }}
          >
            <ChevronLeft size={18} /> Back
          </Button>

          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}

            <Button className="overlay-disable" style={{ width: '250px' }} color="primary" onClick={handleSubmit}>
              Proceed to Pricing
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AssignZonesToVendors;
